import React, { useEffect, useState } from "react";
import i18n from "utils/i18n";
import FetchTimeslotKindExceptions from 'utils/fetch/FetchTimeslotKindExceptions'
import ThemedContainerButton from 'components/atoms/ThemedContainerButton'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import Button from 'theme/Button'
import PreviewTimeslotKind from 'scenes/management/timeslots/timeslot_kind/_components/PreviewTimeslotKind'
import { useNavigation } from '@react-navigation/native'
import { AppRoutes } from 'navigations/app-routes'
import _ from 'lodash'
import ThemedList from 'components/atoms/ThemedList'
import { listArrow } from 'styles/list'
import ListItem from 'components/atoms/ListItem'
import LoadingComponent from 'components/atoms/Loading'
import Text from "theme/Text";
import { textStyles } from 'styles/text'
import ThemedBlock from 'components/atoms/ThemedBlock'
import VStack from 'components/atoms/stack/VStack'

const ManagementTimeslotKindExceptionTab = ( { saveForm, updateTimeslotKind, timeslotKind, isSaving }) => {
	
	const navigation = useNavigation();
	
	const [ loading, setLoading ] = useState( true )
	const [ timeslotKindExceptions, setTimeslotKindExceptions ] = useState([] )
	
	const onPressAdd = () => {
		navigation.navigate( AppRoutes.MANAGEMENT_TIMESLOT_KIND_EXCEPTION_EDIT, {
			timeslotKindGuid: timeslotKind.guid
		})
	}
	
	const onPressView = ( item ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_TIMESLOT_KIND_EXCEPTION_EDIT, {
			timeslotKindExceptionGuid: item.guid
		})
	}
	
	const fetch = () => {
		FetchTimeslotKindExceptions.fetchAll({
			timeslotKindGuid: timeslotKind.guid,
			callbackSuccess: result => {
				setTimeslotKindExceptions( result )
				setLoading( false )
			},
			callbackError: () => {
				setLoading( false )
			},
			callbackStart: () => {
				setLoading( true )
			}
		})
	}
	
	const renderItem = ( { item } ) => {
		// Create the title
		let subtitle = [];
		_.forEach( ['can_overlap_with_booking', 'can_only_select_one_per_day'], name => {
			const value = _.get( item, name, null );
			if( value !== null ) {
				const nameTranslation = i18n.t(`management:form.${name}.title`);
				const valueTranslation = i18n.t( `basic.${value}`);
				
				subtitle.push( nameTranslation +': '+ valueTranslation )
			}
		})
		
		return (
			<ListItem
				title={ i18n.t( `management:form.timeslot_kind_available_for.${item.available_for}`) }
				subtitle={ subtitle.join("\r\n") }
				title_add_active_tag={ true }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ onPressView }
			/>
		)
	}
	
	useEffect( () => {
		return fetch();
	}, [] )
	
	let content = <LoadingComponent />;
	if( !loading ) {
		
		content = (
			<ThemedBlock transparent mediumPadding>
				<Text style={ textStyles.textCenter }>
					{ i18n.t( 'management:generic.no_results' ) }
				</Text>
			</ThemedBlock>
		)
		
		if( timeslotKindExceptions.length > 0 ) {
			content = (
				<ThemedList
					data={ timeslotKindExceptions }
					renderItem={ renderItem.bind( this ) }
					scrollEnabled={ false }
				/>
			)
		}
	}
	
	return (
		<VStack>
			<PreviewTimeslotKind
				timeslotKind={ timeslotKind }
			/>
			
			<ThemedContainerButton
				buttons={(
					<Button
						onPress={ onPressAdd }
						icon={ <Icon icon={ IconSystemConstants.PLUS } /> }>
						
						{ i18n.t( 'management:generic.add') }
					</Button>
				)}>
			
				{ content }
			</ThemedContainerButton>
		</VStack>
	);
}


export default ManagementTimeslotKindExceptionTab
